import React from 'react'
import './Skills.css'

import Aos from "aos"
import { useEffect } from 'react'
import 'aos/dist/aos.css'

import ProjectBox from '../../components/ProjectBox/ProjectBox'
import img7 from  '../../images/JavaScript-01.png'
import img5 from  '../../images/Node-JS-01.png'
import img3 from  '../../images/React-01.png'
import img4 from  '../../images/HTML-5-logo-vector-01.png'
import img1 from  '../../images/CSS-3-01.png'
import img2 from  '../../images/Bootstrap-01.png'
import img6 from  '../../images/cpp.png'
import img8 from  '../../images/MongoDB-01.png'

function Skills() {
  useEffect(() =>{
    Aos.init({
      duration : 500
    })
  },[])
  return (
    <div id='Skills' className='project'>
      <h1>My Skills</h1>
      <div data-aos = "fade-up">
        <div className="boxes">
          <div className="carousel owl-carousel">
            <ProjectBox title = "JavaScript" img= {img7} link = "#"  />
            <ProjectBox title = "Node Js" img= {img5} link = "#"  />
            <ProjectBox title = "React" img= {img3} link = "#"  />
            <ProjectBox title = "HTML 5" img= {img4} link = "#"  />
            <ProjectBox title = "CSS 3" img= {img1} link = "#"  />
            <ProjectBox title = "BootStrap" img= {img2} link = "#"  />
            <ProjectBox title = "C++" img= {img6} link = "#"  />
            <ProjectBox title = "MongoDB" img= {img8} link = "#"  />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Skills
